import { createSlice } from '@reduxjs/toolkit';

const initialHeaderState = {
    sortedButtons: [
        'fullScreen',
        'deepSearch',
        'systemConfig',
        'support',
        'fontSize',
        'calculator',
        'tips',
        'tasks',
        'contacts',
        'calendar',
        'alerts',
        'mailBox',
        'filesManager',
    ]
}

const headerSlice = createSlice({
    name: 'header',
    initialState: initialHeaderState,
    reducers: {
        updateSortedButtons (state, actions) {
            state.sortedButtons = actions.payload;
        }
    }
})

export const headerActions = headerSlice.actions;
export default headerSlice;